import { NgService } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { AuthService } from "@app/services/auth.service";
import { INameValue, IRootScope } from "@models";
import { icons } from "@tools";

@NgService({
    token: Token.KbService,
    dependencies: [
        Token.$RootScope,
        Token.AuthService,
        Token.$Q,
        Token.$Timeout
    ]
})
export class KbService {
    constructor(
        private $rootScope: IRootScope,
        private authService: AuthService,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService
    ) {

    }

    public loc(key: string): string {
        if (key) {
            const lkey = key.toLowerCase();
            if (loc[lkey]) {
                return loc[lkey];
            }
        }
        return key;
    }

    public icon(key: string): string {
        let icon = icons[key];
        if (!icon) {
            icon = key;
        }

        return icon;
    }

    public getExtension(path: string): string {
        if (!path) { return ""; }

        return path.split(".").pop().toLowerCase();
    }

    /**
     * given a kb enum type, gives back an array of NameValue objects
     * with localized names that can be used in a kbSelect
     *
     */
    public getEnumSelects(enm: any, enumName: string): INameValue[] {
        const selects: INameValue[] = [];
        for (const name in enm) {
            const locName = enumName + "_" + name + "_title";
            const locValue = this.loc(locName);

            selects.push({
                name: locValue,
                value: enm[name]
            });
        }
        return selects;
    }

    public fxConvert = (val, to, from = null) => {
        if (!from) from = this.$rootScope.companySettings.currency.toUpperCase();
        return fx(val).from(from).to(to.toUpperCase());
    }

    public copyDataToClipboard(data?: string) {

        const $el = jQuery('<div class="copyPopup"><p>Copy the Json below and use \'Paste Json\' in another location.</p></div>');
        const $textarea = jQuery('<textarea></textarea>');
        jQuery("body").find(".copyPopup").remove();
        $el.append($textarea);
        this.$timeout(() => {
            const textarea: HTMLTextAreaElement = $textarea.get(0) as HTMLTextAreaElement;
            $textarea.val(data);
            $textarea.focus();
            textarea.setSelectionRange(0, 999999);
            textarea.addEventListener("keydown", (ev) => {
                if (ev.key == "c" && ev.ctrlKey) {
                    this.$timeout(() => {
                        $el.remove();
                    }, 1);
                }
                if (ev.key == "Escape") {
                    this.$timeout(function () {
                        $el.remove();
                    }, 1);
                }
            });
        }, 1);
        jQuery("body").append($el);
    }

    public pasteClipboardData(): ng.IPromise<string> {

        const defer = this.$q.defer<string>();
        jQuery("body").find(".copyPopup").remove();

        const $el = jQuery('<div class="copyPopup"><p>Paste the Json below.</p></div>');
        const $textarea = jQuery('<textarea></textarea>');
        $el.append($textarea);
        jQuery("body").append($el);
        this.$timeout(() => {
            const textarea: HTMLTextAreaElement = $textarea.get(0) as HTMLTextAreaElement;
            $textarea.focus();
            textarea.setSelectionRange(0, 999999);
            textarea.addEventListener("keydown", (ev) => {
                if (ev.key == "v" && ev.ctrlKey) {
                    this.$timeout(() => {
                        defer.resolve($textarea.val() as string);
                        $el.remove();
                    }, 1);
                }
                if (ev.key == "Escape") {
                    this.$timeout(function () {
                        $el.remove();
                    }, 1);
                }
            });
        }, 1);

        return defer.promise;
    }

    public fxConvertAsync(val: number, to: string): ng.IPromise<number> {
        const deferred = this.$q.defer<number>();
        deferred.resolve(this.fxConvert(val, to));
        return deferred.promise;
    }

    public fly = (sourceSelector: string, targetSelector: string, callback?: () => void) => {
        const $source = $(sourceSelector).eq(0);
        const $target = $(targetSelector).eq(0);

        if ($source) {
            const $fly = $source.clone()
                .offset({
                    top: $source.offset().top,
                    left: $source.offset().left
                })
                .css({
                    "opacity": "0.5",
                    "position": "fixed",
                    "height": $source.height(),
                    "width": $source.width(),
                    "z-index": "1000"
                })
                .appendTo($("body"))
                .animate({
                    top: $target.offset().top,
                    left: $target.offset().left,
                    width: $target.width(),
                    height: $target.height()
                }, 800, "easeInOutSine", () => {
                    $fly.remove();
                    if (callback) callback();
                    $target.effect("bounce", { distance: 10, times: 5 }, 500);
                });
        }

    }
}
